var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRightArrowWhiteBig = function SvgRightArrowWhiteBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 13 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.558.437A1.5 1.5 0 1 0 .442 2.563L8.916 11 .442 19.437a1.5 1.5 0 0 0 2.116 2.126l9.542-9.5a1.5 1.5 0 0 0 0-2.126L2.558.437Z",
    fill: "#fff"
  })));
};

export default SvgRightArrowWhiteBig;